export const THEMES_NAME = {
  jbsFriboi: 'jbsFriboi',
  swift: 'swift',
  sampco: 'sampco',
  standard: 'standard',
  friboiProcessados: 'friboiProcessados',
  friboiInnatura: 'friboiInnatura'
}

export const LINE_TYPES = {
  INNATURA: 'INNATURA',
  PROCESSED: 'PROCESSED',
  OFFAL: 'OFFAL',
  DISTRIBUTION: 'DISTRIBUTION'
}

export const TABS_BY_TYPE = {
  [LINE_TYPES.INNATURA]: [1, 2, 3, 5, 6],
  [LINE_TYPES.PROCESSED]: [1, 2, 3, 4, 5, 6],
  [LINE_TYPES.OFFAL]: [1, 2, 3, 5, 6],
  [LINE_TYPES.DISTRIBUTION]: [1, 2, 3, 5]
}

export const LINE_TYPE_BY_THEME = {
  [THEMES_NAME.friboiInnatura]: LINE_TYPES.INNATURA,
  [THEMES_NAME.friboiProcessados]: LINE_TYPES.PROCESSED,
  [THEMES_NAME.jbsFriboi]: LINE_TYPES.INNATURA,
  [THEMES_NAME.swift]: LINE_TYPES.PROCESSED,
  [THEMES_NAME.sampco]: LINE_TYPES.DISTRIBUTION,
  [THEMES_NAME.standard]: LINE_TYPES.INNATURA
}

export const getLineTypeByTheme = (theme: string) => {
  return LINE_TYPE_BY_THEME[theme]
}

export const getTabsByTheme = (theme: string) => {
  const lineType = getLineTypeByTheme(theme)
  return TABS_BY_TYPE[lineType]
}

export default {
  // appTheme: checkUrlForTheme()
  appTheme: 'standard'
}
